/**
 * Copyright © 2018 Galaxy Software Services https://github.com/GSS-FED/vital-ui-kit-react
 * MIT license
 */
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import styled from 'styled-components';
import { rgba } from 'polished';
import { CheckIcon } from './CheckIcon';
import { defaultTheme } from '@vital-ui/react-theme';
import cn from 'classnames';
import { CheckboxContext } from './CheckboxContext';
var Root = styled.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-size: 15px;\n  cursor: pointer;\n  margin-right: 5px;\n  display: inline-block;\n  &:hover {\n    > span:first-child {\n      box-shadow: ", ";\n    }\n  }\n"], ["\n  font-size: 15px;\n  cursor: pointer;\n  margin-right: 5px;\n  display: inline-block;\n  &:hover {\n    > span:first-child {\n      box-shadow: ",
    ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return "0 0 0 2px " + rgba(theme.colors.primary, 0.2);
});
Root.defaultProps = {
    theme: defaultTheme,
};
var Label = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.checkbox.label.color;
});
Label.defaultProps = {
    theme: defaultTheme,
};
var CheckWrapper = styled('span')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  box-sizing: border-box;\n  position: relative;\n  display: inline-block;\n  width: ", ";\n  height: ", ";\n  border: ", ";\n  border-radius: ", ";\n  background-color: ", ";\n  transition: ", ";\n  margin: -2px 0.6em 0 0;\n  vertical-align: middle;\n\n  border-color: ", ";\n"], ["\n  box-sizing: border-box;\n  position: relative;\n  display: inline-block;\n  width: ", ";\n  height: ", ";\n  border: ", ";\n  border-radius: ", ";\n  background-color: ",
    ";\n  transition: ", ";\n  margin: -2px 0.6em 0 0;\n  vertical-align: middle;\n\n  border-color: ",
    ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.checkbox.size;
}, function (_a) {
    var theme = _a.theme;
    return theme.checkbox.size;
}, function (_a) {
    var theme = _a.theme;
    return "1px solid " + theme.checkbox.borderColor;
}, function (props) { return (props.round ? '50%' : '2px'); }, function (_a) {
    var checked = _a.checked, round = _a.round, theme = _a.theme;
    return checked
        ? theme.checkbox.checkedBg
        : round
            ? theme.checkbox.roundBg
            : theme.checkbox.bg;
}, function (_a) {
    var theme = _a.theme;
    return theme.defaultTransition;
}, function (_a) {
    var checked = _a.checked, theme = _a.theme;
    return checked ? theme.checkbox.checkedBorderColor : '';
});
CheckWrapper.defaultProps = {
    theme: defaultTheme,
};
var Input = styled.input(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: none;\n"], ["\n  display: none;\n"])));
var IconWrapper = styled('div')(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  text-align: center;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  opacity: ", ";\n  transform: ", ";\n  pointer-events: none;\n  transition: all 120ms ease-out;\n  color: ", ";\n"], ["\n  text-align: center;\n  width: 100%;\n  height: 100%;\n  position: relative;\n  opacity: ", ";\n  transform: ", ";\n  pointer-events: none;\n  transition: all 120ms ease-out;\n  color: ",
    ";\n"])), function (_a) {
    var checked = _a.checked;
    return (checked ? 1 : 0);
}, function (_a) {
    var checked = _a.checked;
    return (checked ? 'scale(1)' : 'scale(0)');
}, function (_a) {
    var round = _a.round, disabled = _a.disabled, theme = _a.theme;
    return iconColor(round, disabled, theme);
});
IconWrapper.defaultProps = {
    theme: defaultTheme,
};
function iconColor(round, disabled, theme) {
    if (theme === void 0) { theme = defaultTheme; }
    if (disabled) {
        return theme.checkbox.icon.disabledColor;
    }
    if (round) {
        return theme.checkbox.icon.roundColor;
    }
    return theme.checkbox.icon.color;
}
/**
 * @render react
 * @name Checkbox
 * @description Checkbox components with group
 * @example
 * <Checkbox.Group>
 *  <Checkbox
 *    round
 *    label="checkbox 1"
 *  />
 *  <Checkbox
 *    round
 *    label="checkbox 2"
 *  />
 *  <Checkbox
 *    round
 *    label="checkbox 3"
 *  />
 * </Checkbox.Group>
 */
var Checkbox = /** @class */ (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Checkbox.prototype.render = function () {
        var _this = this;
        var _a = this.props, defaultChecked = _a.defaultChecked, _b = _a.disabled, disabled = _b === void 0 ? false : _b, icon = _a.icon, label = _a.label, name = _a.name, _c = _a.round, round = _c === void 0 ? false : _c, theme = _a.theme, style = _a.style, className = _a.className, onChange = _a.onChange, onValueChange = _a.onValueChange, props = __rest(_a, ["defaultChecked", "disabled", "icon", "label", "name", "round", "theme", "style", "className", "onChange", "onValueChange"]);
        return (React.createElement(CheckboxContext.Consumer, null, function (_a) {
            var contextRound = _a.round, contextDisabled = _a.disabled, contextIcon = _a.icon;
            return (React.createElement(Root, { style: style, className: cn('vital__checkbox', className) },
                React.createElement(CheckWrapper, { checked: _this.props.checked, round: contextRound || round },
                    React.createElement(IconWrapper, { checked: _this.props.checked }, contextIcon ||
                        icon || (React.createElement(CheckIcon, { size: _this.props.theme.checkbox.icon.size })))),
                React.createElement(Label, null,
                    React.createElement(Input, __assign({ type: "checkbox", disabled: contextDisabled || disabled, checked: _this.props.checked, defaultChecked: defaultChecked, name: name }, props, { onChange: function (e) {
                            if (onChange) {
                                onChange(e);
                            }
                            if (onValueChange) {
                                onValueChange(!_this.props.checked);
                            }
                        } })),
                    label)));
        }));
    };
    Checkbox.defaultProps = {
        disabled: false,
        round: false,
        icon: undefined,
        theme: defaultTheme,
        style: undefined,
        className: '',
    };
    return Checkbox;
}(React.Component));
export { Checkbox };
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=Checkbox.js.map